import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=c95699ca&scoped=true&"
import script from "./password-reset.vue?vue&type=script&lang=js&"
export * from "./password-reset.vue?vue&type=script&lang=js&"
import style0 from "./password-reset.vue?vue&type=style&index=0&id=c95699ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95699ca",
  null
  
)

export default component.exports